import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiListItemButton = {
  defaultProps: { disableRipple: true },
  styleOverrides: { root: { gap: '16px' } },
} satisfies Components<Theme>['MuiListItemButton'];
